<template>
  <div class="container" v-loading="loading">
   <div class="search-bar">
      <el-button class="add-btn" icon="el-icon-plus" @click="addItem" v-if="website.roleType === 'factory'">{{$t('hirePurchase.add')}}</el-button>
      <div class="right">
        <el-autocomplete
            v-model="keyword"
            :fetch-suggestions="querySearchAsync"
            :trigger-on-focus="false"
            clearable
            value-key="name"
            :placeholder="$t('applyChild.pleInputCon')"
            @select="handleKeywordSelect"
            @keyup.enter.native="search"
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <button slot="append" class="search-btn" @click="search">{{$t('tagsView.search')}}</button>
        </el-autocomplete>
        <div class="advance-filter" @click="showDrawer">
          <i class="iconfont icon-shaixuan"></i>
          <span class="title">{{$t('complaintList.highSearch')}}</span>
        </div>
      </div>
   </div>
   <div class="empty_" v-if="!dataSource.length">
      <el-empty :description="$t('complaintList.noData')"></el-empty>
   </div>
   <div class="list" v-else>
    <div class="list-item"
    v-for="(item, index) in dataSource"
    :key="index"
    @click="toDetail(item.id)"
    >
        <div class="goods-img" v-imagePreview>
            <img :src="item.photo" alt="">
        </div>
        <div class="goods-info">
          <p class="price-info">
            <span class="unit">{{ item.unit }}</span>
            <span class="price">{{ item.price }}</span>
          </p>

          <div class="row"> <div class="col">
                <div class="label">{{$t('applyChild.code')}}：</div>
                <div class="content">{{ item.code }}</div>
            </div> </div>
           <div class="row">  <div class="col">
                <div class="label">{{$t('warehouseDetail.name')}}：</div>
                <div class="content">{{ item.name }}</div>
            </div> </div>
          <!-- <p class="goods-title">名称： {{ item.name }}</p> -->
          <div class="row">

            <div class="col">
                <div class="label">{{$t('applyChild.model')}}：</div>
                <div class="content">{{ item.model }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col">
                <div class="label">{{$t('applyChild.size')}}：</div>
                <div class="content">{{ item.specification }}</div>
            </div>
          </div>
        </div>
    </div>
   </div>
    <div class="pagination_">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="listReq.current"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="listReq.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listReq.total">
    </el-pagination>
    </div>
    <FilterDrawer
    @faction="faction"
    :defaultInfo="currentInfo"
    v-if="drawerVisible"
    :visible.sync="drawerVisible"
    />
  </div>
</template>

<script>
import website from "@/config/website";
import {
getProductList,
getPartList,
getMaterialList,
getProductFilter,
getPartFilter,
getMaterialFilter,
} from "../../api/goods/index";
import FilterDrawer from "../../components/drawer/filter.vue";
  export default {
    components: {
        FilterDrawer
    },
    data() {
      return {
        keyword: '',
        searchList: [],
        dataSource: [],
        drawerVisible: false,
        loading: false,
        timeout: null,
        listApi: null,
        keywordApi: null,
        currentInfo: {}
      }
    },
    computed: {
      listReq() {
        return {
            current: 1,
            size: 20,
            total: 0,
            name: '',
            code: '',
            model: '',
            specification: '',
            contentQuery: this.keyword
        }
      },
      website() {
        return website
      }
    },
    created() {
      console.log(this.website.roleType)
      this.getList();
      this.getKeywordList();
    },
    methods: {
      // 分页接口切换
      hadleChangeListApi(e) {
        switch(e) {
            case 'product':
                return getProductList;
            case 'part':
                return getPartList;
            case 'material':
                return getMaterialList;
        }
      },
      // 关键词搜索切换
      handleKeywordApiChange(e) {
        switch(e) {
            case 'product':
                return getProductFilter;
            case 'part':
                return getPartFilter;
            case 'material':
                return getMaterialFilter;
        }
      },
      faction(e) {
        console.log(e);
        this.listReq.name = e && e.name ? e.name : '';
        this.listReq.code = e && e.code ? e.code : '';
        this.listReq.model = e && e.model ? e.model : '';
        this.listReq.specification = e && e.specification ? e.specification : '';
        this.currentInfo.name = e && e.name ? e.name : '';
        this.currentInfo.code = e && e.code ? e.code : '';
        this.currentInfo.model = e && e.model ? e.model : '';
        this.currentInfo.specification = e && e.specification ? e.specification : '';
        this.getList();
      },
      search() {
        this.getList();
      },
      showDrawer() {
        this.drawerVisible = true;
      },
      addItem() {
        this.$router.push({
          path: `/goods/${this.$route.meta.type}-new`,
          query: {
            type: this.$route.meta.typeId
          }
        })
      },
      toDetail(id) {
        this.$router.push({
          path: `/goods/${this.$route.meta.type}-detail`,
          query: {
            id,
            type: this.$route.meta.typeId
          }
        })
      },
      querySearchAsync(queryString, cb) {
        var searchList = this.searchList;
        var results = queryString ? searchList.filter(this.createStateFilter(queryString)) : searchList;
        console.log(results);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 3000 * Math.random());
      },
      createStateFilter(queryString) {
        return (state) => {
            console.log(state);
          return (state.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleKeywordSelect(item) {
        console.log(item);
        this.keyword = item.name;
        this.getList();
      },
      handleSizeChange(val) {
        console.log(this.$t('complaintList.everyPage') + `${val}` + this.$t('complaintList.bar'));
        this.listReq.size = val;
        this.getList();
      },
      handleCurrentChange(val) {
        console.log(this.$t('complaintList.momentPage') + `: ${val}`);
        this.listReq.current = val;
        this.getList();
      },
      async getKeywordList() {
       this.keywordApi = this.handleKeywordApiChange(this.$route.meta.type);
        let params = {
            selectCondition: 'name',
            type: this.$route.meta.typeId
        }
       const res = await this.keywordApi(params);
       console.log('filter =>', res);
       if(res.data && res.data.code === 200) {
        this.searchList = res.data.data;
       }
      },
      async getList() {
        this.loading = true;
        this.listApi = this.hadleChangeListApi(this.$route.meta.type)
        const res = await this.listApi({...this.listReq, type: this.$route.meta.typeId});
        console.log('res =>', res);
        if(res.data && res.data.code == 200) {
           this.dataSource = res.data.data.records;
           this.listReq.total = res.data.data.total;
        }
        this.loading = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
    background-color: #f0f2f5;
    height: 100%;
    overflow: auto;
}
.search-bar {
    display: flex;
    justify-content: space-between;
    padding: 0 19px;
    align-items: center;
    min-height: 64px;
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
    border-radius: 4px;
    .add-btn {
        background: #50C4CB;
        color: #fff;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }
    .right {
        display: flex;
        align-items: center;
        .advance-filter {
            margin-left: 25px;
            .title {
              margin-left: 8px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
            }
        }
        .search-btn {
            background: #59CFD6;
            border: none;
            color: #fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
        }
        .advance-filter:hover {
            cursor: pointer;
            color: #59CFD6;
        }
    }
    /deep/ .el-autocomplete input {
        border-color: #59CFD6;
    }
    /deep/ .el-input-group__append {
        background-color: #59CFD6;
    }
}
.list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 3rem;
    margin-top: 20px;
    .list-item {
        display: flex;
        flex-direction: column;
        width: 312px;
        padding: 20px 19px;
        background: #FFFFFF;
        border-radius: 4px;
        box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
        .goods-img {
            margin: 0 auto;
            width: 239px;
            height: 196px;
             & > img {
                width: 100%;
                height: 100%;
             }
             -webkit-filter: drop-shadow(5px 5px 5px rgba(0,0,0,.5));
             filter: drop-shadow(5px 5px 5px rgba(0,0,0,.5));
        }
        .goods-info {
            .price-info {
                font-family: Source Han Sans CN;
                margin-top: 10px;
                margin-bottom: 18px;
                font-weight: 500;
                color: #FD894A;
                .unit {
                    font-size: 12 * 0.8px;
                }
                .price {
                    font-size: 16px;
                }
            }
        }
        .goods-title {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            margin-bottom: 17px;
        }
        .goods-title:hover {
            text-decoration: underline;
        }
        .row {
            display: flex;
            justify-content: space-between;
            flex-wrap: nowrap;
            align-items: center;
            margin-bottom: 18px;
        }
        .col {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
        }
        .label {
            min-width: 20%;
            color: #999999;
        }
        .content {
            flex: 1;
            color: #333333;
        }
    }
    .list-item:hover  {
      cursor: pointer;
    }
}
.pagination_ {
  position: fixed;
  right: 23px;
  bottom: 24px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #01AAA7;
}
</style>
